<template>
    <div class="testimonials-slider-controls__buttons">
        <VJoyIconButton
            :class="['testimonials-slider-controls__button', 'swiper-button', 'swiper-button-prev', navigationPrevClass]"
            icon="arrow-left"
            size="medium"
            :aria-label="prevArrowLabel || 'Previous testimonial'"
            data-testid="testimonials-arrow-left"
        />
        <VJoyIconButton
            :class="['testimonials-slider-controls__button', 'swiper-button', 'swiper-button-next', navigationNextClass]"
            icon="arrow-right"
            size="medium"
            :aria-label="nextArrowLabel || 'Next testimonial'"
            data-testid="testimonials-arrow-right"
        />
    </div>
</template>

<script setup lang="ts">
    import {VJoyIconButton} from '@maltjoy/core-vue';

    type Props = {
        navigationPrevClass: string;
        navigationNextClass: string;
        prevArrowLabel?: string | null;
        nextArrowLabel?: string | null;
    };

    defineProps<Props>();
</script>

<style lang="scss">
    .testimonials-slider-controls__buttons {
        .joy-button:not(:disabled) {
            background-color: transparent;
            border: 1px solid var(--joy-color-primary-50);
            color: var(--joy-color-primary-50);

            &:hover {
                background-color: var(--joy-color-primary-50);
                color: var(--joy-color-neutral-0);
            }
        }
    }
</style>
